import type { UserCapabilities } from "@/hooks/useUserCapabilities";

export function firstNameFromLabel(name: string | null | undefined): string {
  const t = (name ?? "").trim();
  if (!t) return "them";
  return t.split(/\s+/)[0] ?? t;
}

type WorkspaceCaps = Pick<
  UserCapabilities,
  "is_cleaner" | "is_owner" | "is_cohost" | "has_cleaner_assignment"
>;

/** Owner who also cleans, or Team on one unit and still assigned to clean another. */
export function isDualWorkspace(caps: WorkspaceCaps): boolean {
  if (caps.is_owner && caps.is_cleaner) return true;
  return caps.is_cohost && caps.is_cleaner && caps.has_cleaner_assignment;
}

/**
 * One workspace only is locked.
 * Team on one unit and Cleaner on another can use both (Slice 25).
 * Make Team on every unit they clean stays on Properties.
 */
export function lockedWorkspace(caps: WorkspaceCaps): "owner" | "cleaner" | null {
  if (isDualWorkspace(caps)) return null;
  if (caps.is_owner || caps.is_cohost) return "owner";
  if (caps.is_cleaner) return "cleaner";
  return null;
}

/** Properties | Jobs on the properties list when they also clean. */
export function showPropertiesWorkspaceChip(caps: WorkspaceCaps): boolean {
  return isDualWorkspace(caps);
}

/** Properties | Jobs on My jobs when they also have properties or a team unit. */
export function showJobsWorkspaceChip(caps: WorkspaceCaps): boolean {
  return isDualWorkspace(caps);
}

export function showAccountWorkspaceBlock(
  caps: Pick<UserCapabilities, "is_cleaner" | "is_owner" | "is_cohost">,
): boolean {
  return caps.is_cleaner;
}

export function isDualRole(
  caps: Pick<UserCapabilities, "is_cleaner" | "is_owner" | "is_cohost" | "has_cleaner_assignment">,
): boolean {
  return isDualWorkspace(caps);
}
